/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TargetJobReportQuery from './TargetJobReportQuery';
import TargetJobReport from './TargetJobReport';
import { AppConstants } from '../../../../shared/Constants';

class TargetJobReportContainer extends Component {
  constructor(props) {
    super(props);
    this.exportReport = this.exportReport.bind(this);
  }

  exportReport(formValues) {
    const virtualForm = document.createElement('form');
    virtualForm.method = 'POST';
    virtualForm.action = AppConstants.PAGE_REPORT_URL;
    virtualForm.target = '_blank';

    for (const prop in formValues) {
      const input = document.createElement('input');
      input.name = prop;
      input.type = 'hidden';
      input.value = formValues[prop];
      virtualForm.appendChild(input);
    }
    document.body.appendChild(virtualForm);
    virtualForm.submit();
    document.body.removeChild(virtualForm);
  }

  render() {
    const {
      activeLocales, assessment, respondent, owner, currentAccount, availableTranslations,
    } = this.props;
    const props_print_friendly_report_status = false;
    const locale = owner && owner.locale ? owner.locale : 'en';
    const reportParams = {
      assessment: assessment.id,
      jobProfile: respondent.targetJob.id,
      printerFriendlyReport: props_print_friendly_report_status,
      locale,
    };
    return (
      <TargetJobReport
        reportParams={reportParams}
        activeLocales={activeLocales}
        exportReport={this.exportReport}
        currentAccount={currentAccount}
        availableTranslations={availableTranslations}
      />
    );
  }
}

TargetJobReportContainer.propTypes = {
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  owner: PropTypes.objectOf(PropTypes.any).isRequired,
  assessment: PropTypes.objectOf(PropTypes.any).isRequired,
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
  activeLocales: PropTypes.arrayOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default TargetJobReportQuery(TargetJobReportContainer);
